import { devError } from '../utils/devLogger';
import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { auth } from '../firebase';

const QANavbar = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const canAccessWhatsApp = ['admin', 'facilitator'].includes(userProfile?.role);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      devError('Failed to log out', error);
    }
  };

  return (
    <Navbar variant="dark" expand="lg" sticky="top" className="navbar-gradient">
      <Container>
        <Navbar.Brand
          onClick={() => navigate('/qa')}
          style={{ cursor: 'pointer' }}
          className="d-flex align-items-center"
        >
          <div className="d-flex align-items-center gap-2">
            <img
              src="/Access70Logo.png"
              alt="Access70"
              height="40"
              style={{ maxHeight: '40px', width: 'auto' }}
            />
            <img
              src="/NPI_Logo.png"
              alt="NPI Governance Solutions"
              height="50"
              style={{ maxHeight: '50px', width: 'auto' }}
            />
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link onClick={() => navigate('/qa')}>QA Dashboard</Nav.Link>
            <Nav.Link onClick={() => navigate('/resources')}>Resources</Nav.Link>
            <Nav.Link onClick={() => navigate('/reports')}>Reports</Nav.Link>
            <Nav.Link onClick={() => navigate('/admin/issues')}>Issues</Nav.Link>
            <Nav.Link onClick={() => navigate('/admin/document-upload')}>Document Upload</Nav.Link>
            <Nav.Link onClick={() => navigate('/qa/sales-dashboard')}>Sales</Nav.Link>
            <NavDropdown title="Composer" id="qa-composer-dropdown">
              <NavDropdown.Item onClick={() => navigate('/email-composer')}>
                Email Composer
              </NavDropdown.Item>
              {canAccessWhatsApp && (
                <NavDropdown.Item onClick={() => navigate('/whatsapp-composer')}>
                  WhatsApp Composer
                </NavDropdown.Item>
              )}
            </NavDropdown>
            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default QANavbar;
